export enum CustomEventType {
  FoundNewVersion = 'FoundNewVersion',
  FcmTokenStored = 'FcmTokenStored',
  FcmMessageReceived = 'FcmMessageReceived',
  ManualHashtagClick = 'ManualHashtagClick',
}
